import { provide, inject } from 'vue'

export const injectionKey = 'contextSpecifics'

export const provideContextSpecifics = (contextSpecificOptions) => {
  const { contextName, assignFn, unAssignFn, syncFn, contextIcon } = contextSpecificOptions

  const config = {
    contextName,
    assignFn,
    unAssignFn,
    syncFn,
    contextIcon
  }

  provide(injectionKey, config)

  return config
}

export const useContextSpecifics = () => {
  const currentOptions = inject(injectionKey)
  return currentOptions
}
